<template>
    <div>
        <div v-if="view" class="fixed z-10 inset-0 overflow-y-auto">
            <div class="flex tickets-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <div class="fixed inset-0 transition-opacity" aria-hidden="true" @click="view = false">
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                <div class="inline-block align-bottom bg-white rounded-lg  text-left overflow-hidden shadow-xl transform transition-all ease-out duration-300 sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                    <div class="flex justify-between tickets-center mb-4 bg-blue-50 border-b border-blue-100 p-4">
                        <p class="text-xl font-semibold text-blue-900">Board Meeting Notes</p>
                        <svg @click="view = false" class="w-6 h-6 text-gray-400 cursor-pointer hover:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                    </div>
                    <div class="px-4 pt-5 pb-4 sm:p-6">
                        <div class="max-w-3xl pb-8 flex items-center justify-between">
                            <h1 class="text-2xl font-medium text-blue-800">{{ note.title }}</h1>
                        </div>
                        <ol class="">
                            <li v-for="(note, index) in note.note_items" class="border-b-2 border-gray-100 ">
                                <div class="note-item">
                                    <public-note-item
                                        type="parent"
                                        :index="index"
                                        :note="note">
                                    </public-note-item>
                                </div>
                                <ol class="divide-y pl-8">
                                    <li v-for="(childNote, idx) in note.children" class="border-t-2 border-gray-100 ">
                                        <div class="child-note-item flex items-center justify-between">
                                            <public-note-item
                                                type="child"
                                                :parent="note"
                                                :index="idx"
                                                :note="childNote">
                                            </public-note-item>
                                        </div>
                                    </li>
                                </ol>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PublicNoteItem from "@/Components/BoardNotes/PublicNoteItem";

export default {
    components: {PublicNoteItem},
    data() {
        return {
            view: false,
            note: {}
        }
    },
    mounted() {
        this.$eventBus.$on('show-public-board-note', (note) => {
            this.view = true
            this.note = note
        })
    }
}
</script>
